/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { CentrifugeCitrus } from "./modelCentrifugeCitrus";

class ControllerCentrifugeCitrus extends ControllerModel {
    constructor() {
        super("ControllerCentrifugeCitrus");

        this.setNewNode = (callback) => {
            let centrifugecitrus = new CentrifugeCitrus();
            centrifugecitrus.decorate(callback);

            this.addNode(centrifugecitrus);
            SingletonFlowchart.SaveStatus()
        }

        this.loadNode = (node, callback) => {
            let centrifugecitrus = new CentrifugeCitrus();
            centrifugecitrus.copyFrom(node);
            centrifugecitrus.decorate(callback);
            this.addNode(centrifugecitrus)
        }

        this.getProperties = async (node) => {
            let n = new CentrifugeCitrus();
            await n.copyFrom(node);
            return n.data
        }

        this.getNode = (node) => {
            let n = new CentrifugeCitrus();
            n.copyFrom(node);
            return n
        }
    }
}

export { ControllerCentrifugeCitrus };